
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';

const LocationMap = () => {
  return (
    <section className="py-12 bg-gradient-to-b from-white to-forti-fi-background">
      <div className="container mx-auto px-4">
        <AnimateInView animation="fade-in">
          <h2 className="text-2xl text-center mb-8 text-forti-fi">Our Location</h2>
          <div className="rounded-lg overflow-hidden shadow-luxury hover:shadow-premium transition-all duration-500">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.6479538264736!2d-79.41629778448797!3d43.77254875094474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2d74c79394a1%3A0x9775299844c48f63!2s Downsview%20Park!5e0!3m2!1sen!2sus!4v1626728936248!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              title="Forti-Fi Location"
            ></iframe>
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default LocationMap;
